/**
 * 将字符串转换为数字
 * @example ‘01:00' String类型
 * @return  60     Number类型
 */
export function toMinutes(value) {
  let array=value.split(':');
  let num1=Number(array[0])*60;
  let num2=Number(array[1]);
  return (num1+num2);
}



// WEBPACK FOOTER //
// ./src/common/js/toMinutes.js